import React from "react";

export function PortalMetricCard({ label, value, hint, icon: Icon, benchmarkHint }) {
  return (
    <div className="portal-card portal-card--pad portal-metric-card">
      <div className="portal-metric-card__body">
        <div className="portal-metric-card__copy">
          {label ? <p className="portal-metric-card__label">{label}</p> : null}
          {value != null ? <p className="portal-metric-card__value">{value}</p> : null}
          {hint ? <p className="portal-metric-card__hint">{hint}</p> : null}
          {benchmarkHint ? <p className="portal-metric-card__benchmark">{benchmarkHint}</p> : null}
        </div>
        {Icon ? (
          <div className="portal-metric-card__icon" aria-hidden="true">
            <Icon size={18} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
